const PenTool = () => {
    return (
        <svg
            width="53"
            height="53"
            viewBox="0 0 53 53"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_2442_162889)">
                <rect width="53" height="53" rx="6" fill="white" />
                <line
                    x1="2.6279"
                    y1="4.9929e-09"
                    x2="2.62789"
                    y2="53"
                    stroke="black"
                    stroke-opacity="0.1"
                    stroke-width="0.228448"
                />
                <line
                    x1="6.28415"
                    y1="4.9929e-09"
                    x2="6.28414"
                    y2="53"
                    stroke="black"
                    stroke-opacity="0.1"
                    stroke-width="0.228448"
                />
                <line
                    x1="9.93844"
                    y1="4.9929e-09"
                    x2="9.93844"
                    y2="53"
                    stroke="black"
                    stroke-opacity="0.1"
                    stroke-width="0.228448"
                />
                <line
                    x1="13.5927"
                    y1="4.9929e-09"
                    x2="13.5927"
                    y2="53"
                    stroke="black"
                    stroke-opacity="0.1"
                    stroke-width="0.228448"
                />
                <line
                    x1="17.249"
                    y1="4.9929e-09"
                    x2="17.249"
                    y2="53"
                    stroke="black"
                    stroke-opacity="0.1"
                    stroke-width="0.228448"
                />
                <line
                    x1="20.9033"
                    y1="4.9929e-09"
                    x2="20.9033"
                    y2="53"
                    stroke="black"
                    stroke-opacity="0.1"
                    stroke-width="0.228448"
                />
                <line
                    x1="24.5595"
                    y1="4.9929e-09"
                    x2="24.5595"
                    y2="53"
                    stroke="black"
                    stroke-opacity="0.1"
                    stroke-width="0.228448"
                />
                <line
                    x1="28.2138"
                    y1="4.9929e-09"
                    x2="28.2138"
                    y2="53"
                    stroke="black"
                    stroke-opacity="0.1"
                    stroke-width="0.228448"
                />
                <line
                    x1="31.8701"
                    y1="4.9929e-09"
                    x2="31.8701"
                    y2="53"
                    stroke="black"
                    stroke-opacity="0.1"
                    stroke-width="0.228448"
                />
                <line
                    x1="35.5244"
                    y1="4.9929e-09"
                    x2="35.5244"
                    y2="53"
                    stroke="black"
                    stroke-opacity="0.1"
                    stroke-width="0.228448"
                />
                <line
                    x1="39.1806"
                    y1="4.9929e-09"
                    x2="39.1806"
                    y2="53"
                    stroke="black"
                    stroke-opacity="0.1"
                    stroke-width="0.228448"
                />
                <line
                    x1="42.8349"
                    y1="4.9929e-09"
                    x2="42.8349"
                    y2="53"
                    stroke="black"
                    stroke-opacity="0.1"
                    stroke-width="0.228448"
                />
                <line
                    x1="46.4892"
                    y1="4.9929e-09"
                    x2="46.4892"
                    y2="53"
                    stroke="black"
                    stroke-opacity="0.1"
                    stroke-width="0.228448"
                />
                <line
                    x1="50.1455"
                    y1="4.9929e-09"
                    x2="50.1455"
                    y2="53"
                    stroke="black"
                    stroke-opacity="0.1"
                    stroke-width="0.228448"
                />
                <line
                    x1="81.7852"
                    y1="0.918912"
                    x2="0.000671377"
                    y2="0.918904"
                    stroke="black"
                    stroke-opacity="0.1"
                    stroke-width="0.228448"
                />
                <line
                    x1="81.7852"
                    y1="4.34079"
                    x2="0.000671377"
                    y2="4.34078"
                    stroke="black"
                    stroke-opacity="0.1"
                    stroke-width="0.228448"
                />
                <line
                    x1="81.7852"
                    y1="7.77047"
                    x2="0.000671377"
                    y2="7.77047"
                    stroke="black"
                    stroke-opacity="0.1"
                    stroke-width="0.228448"
                />
                <line
                    x1="81.7852"
                    y1="11.2002"
                    x2="0.000671377"
                    y2="11.2002"
                    stroke="black"
                    stroke-opacity="0.1"
                    stroke-width="0.228448"
                />
                <line
                    x1="81.7852"
                    y1="14.622"
                    x2="0.000671377"
                    y2="14.622"
                    stroke="black"
                    stroke-opacity="0.1"
                    stroke-width="0.228448"
                />
                <line
                    x1="81.7852"
                    y1="18.0517"
                    x2="0.000671377"
                    y2="18.0517"
                    stroke="black"
                    stroke-opacity="0.1"
                    stroke-width="0.228448"
                />
                <line
                    x1="81.7852"
                    y1="21.4814"
                    x2="0.000671377"
                    y2="21.4814"
                    stroke="black"
                    stroke-opacity="0.1"
                    stroke-width="0.228448"
                />
                <line
                    x1="81.7852"
                    y1="24.9033"
                    x2="0.000671377"
                    y2="24.9033"
                    stroke="black"
                    stroke-opacity="0.1"
                    stroke-width="0.228448"
                />
                <line
                    x1="81.7852"
                    y1="28.333"
                    x2="0.000671377"
                    y2="28.333"
                    stroke="black"
                    stroke-opacity="0.1"
                    stroke-width="0.228448"
                />
                <line
                    x1="81.7852"
                    y1="31.7548"
                    x2="0.000671377"
                    y2="31.7548"
                    stroke="black"
                    stroke-opacity="0.1"
                    stroke-width="0.228448"
                />
                <line
                    x1="81.7852"
                    y1="35.1845"
                    x2="0.000671377"
                    y2="35.1845"
                    stroke="black"
                    stroke-opacity="0.1"
                    stroke-width="0.228448"
                />
                <line
                    x1="81.7852"
                    y1="38.6142"
                    x2="0.000671377"
                    y2="38.6142"
                    stroke="black"
                    stroke-opacity="0.1"
                    stroke-width="0.228448"
                />
                <line
                    x1="81.7852"
                    y1="42.0361"
                    x2="0.000671377"
                    y2="42.0361"
                    stroke="black"
                    stroke-opacity="0.1"
                    stroke-width="0.228448"
                />
                <line
                    x1="81.7852"
                    y1="45.4658"
                    x2="0.000671377"
                    y2="45.4658"
                    stroke="black"
                    stroke-opacity="0.1"
                    stroke-width="0.228448"
                />
                <line
                    x1="81.7852"
                    y1="48.8955"
                    x2="0.000671377"
                    y2="48.8955"
                    stroke="black"
                    stroke-opacity="0.1"
                    stroke-width="0.228448"
                />
                <line
                    x1="81.7852"
                    y1="52.3173"
                    x2="0.000671377"
                    y2="52.3173"
                    stroke="black"
                    stroke-opacity="0.1"
                    stroke-width="0.228448"
                />
                <rect
                    x="6.85"
                    y="6.85"
                    width="39.3"
                    height="39.3"
                    fill="#FFF9D5"
                />
                <rect
                    x="6.85"
                    y="6.85"
                    width="39.3"
                    height="39.3"
                    stroke="#4B3DF7"
                    stroke-width="0.7"
                    stroke-dasharray="1.29 1.29"
                />
                <rect
                    x="5.52763"
                    y="5.52958"
                    width="1.94535"
                    height="1.94535"
                    rx="0.41686"
                    fill="white"
                    stroke="#4B3DF7"
                    stroke-width="0.277907"
                />
                <rect
                    x="5.24247"
                    y="45.2405"
                    width="1.94535"
                    height="1.94535"
                    rx="0.41686"
                    fill="white"
                    stroke="#4B3DF7"
                    stroke-width="0.277907"
                />
                <rect
                    x="45.2425"
                    y="45.2405"
                    width="1.94535"
                    height="1.94535"
                    rx="0.41686"
                    fill="white"
                    stroke="#4B3DF7"
                    stroke-width="0.277907"
                />
                <rect
                    x="45.2132"
                    y="5.52958"
                    width="1.94535"
                    height="1.94535"
                    rx="0.41686"
                    fill="white"
                    stroke="#4B3DF7"
                    stroke-width="0.277907"
                />
                <path
                    d="M30.0877 34.7506C29.9315 34.9068 29.7195 34.9945 29.4986 34.9945C29.2776 34.9945 29.0657 34.9068 28.9094 34.7506L27.5877 33.4289C27.4315 33.2726 27.3438 33.0607 27.3438 32.8397C27.3438 32.6187 27.4315 32.4068 27.5877 32.2506L32.2427 27.5956C32.399 27.4393 32.6109 27.3516 32.8319 27.3516C33.0529 27.3516 33.2648 27.4393 33.4211 27.5956L34.7427 28.9172C34.899 29.0735 34.9867 29.2854 34.9867 29.5064C34.9867 29.7274 34.899 29.9393 34.7427 30.0956L30.0877 34.7506Z"
                    stroke="#4B3DF7"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M32.0013 27.8385L30.8555 22.1102C30.8243 21.9544 30.7492 21.8107 30.6391 21.6961C30.5289 21.5815 30.3883 21.5008 30.2338 21.4635L19.6971 18.6952C19.5583 18.6617 19.4132 18.6643 19.2757 18.703C19.1383 18.7416 19.013 18.815 18.912 18.916C18.8111 19.0169 18.7377 19.1422 18.6991 19.2797C18.6604 19.4171 18.6577 19.5622 18.6913 19.701L21.4596 30.2377C21.4969 30.3922 21.5776 30.5328 21.6922 30.643C21.8068 30.7531 21.9505 30.8282 22.1063 30.8594L27.8346 32.0052"
                    stroke="#4B3DF7"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M18.918 18.9141L24.9896 24.9857"
                    stroke="#4B3DF7"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M26.1667 27.8333C27.0871 27.8333 27.8333 27.0871 27.8333 26.1667C27.8333 25.2462 27.0871 24.5 26.1667 24.5C25.2462 24.5 24.5 25.2462 24.5 26.1667C24.5 27.0871 25.2462 27.8333 26.1667 27.8333Z"
                    stroke="#4B3DF7"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </g>
            <rect
                x="0.5"
                y="0.5"
                width="52"
                height="52"
                rx="5.5"
                stroke="#EEEEEE"
            />
            <defs>
                <clipPath id="clip0_2442_162889">
                    <rect width="53" height="53" rx="6" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default PenTool
